import React from 'react'
import CampaignFlowBuilder from '.'

const EditFlow = () => {
    return (
        <CampaignFlowBuilder isEdit={true} />
    )
}

export default EditFlow